<template>
  <div v-if="one" class="item">
    <div class="item_title">
      {{
        localStorage.translations.pages['setting-personal_area'].sections[
          'adres-prozhivaniya-v-finlyandii'
        ]
      }}
    </div>
    <div class="item_data">
      <span class="date">{{ address.street || address.city || address.zip ? address.street + ' ' + address.city + ', ' + address.zip : '-' }}</span>
    </div>
  </div>
  <div v-else-if="two && additionalAddress[0]" class="item">
    <div class="item_title">
      {{ additionalAddress[0].name }}
    </div>
    <div class="item_data">
      <span class="date">{{
        additionalAddress[0].street +
        ' ' +
        additionalAddress[0].city +
        ', ' +
        additionalAddress[0].zip
      }}</span>
    </div>
  </div>
  <div v-else-if="three && additionalAddress[1]" class="item">
    <div class="item_title">
      {{ additionalAddress[1].name }}
    </div>
    <div class="item_data">
      <span class="date">{{
        additionalAddress[1].street +
        ' ' +
        additionalAddress[1].city +
        ', ' +
        additionalAddress[1].zip
      }}</span>
    </div>
  </div>
  <div v-else-if="four && additionalAddress[2]" class="item">
    <div class="item_title">
      {{ additionalAddress[2].name }}
    </div>
    <div class="item_data">
      <span class="date">{{
        additionalAddress[2].street +
        ' ' +
        additionalAddress[2].city +
        ', ' +
        additionalAddress[2].zip
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactAddressPdf',
  props: ['address', 'additional_address', 'one', 'two', 'three', 'four'],
  components: {},
  data: () => ({
    additionalAddress: [],
  }),
  watch: {
    additional_address() {
      if (this.additional_address) {
        this.additionalAddress = JSON.parse(this.additional_address.data)
      }
    },
  },
  mounted() {
    if (this.additional_address) {
      this.additionalAddress = JSON.parse(this.additional_address.data)
    }
  },
}
</script>

<style lang="scss" scoped>
.item {
  &_title {
    border: 1px solid #dbdbdb;
    padding: 8px 10px;
    color: #2c2c2c;
    font-size: 16px;
    display: grid;
    grid-template-columns: max-content max-content;
    justify-content: space-between;
    font-weight: bold;
  }
  &_data {
    padding: 10px;
    font-weight: normal;
    font-size: 14px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    .date {
      color: #2c2c2c;
      letter-spacing: 0.04em;
    }
  }
}
</style>
